<div class="modal-body">

    <img [src]="base64" alt="" *ngIf="base64" style="width:100%" />

</div>

<div class="modal-footer bg-light text-right">
    <button ngbAutoFocus type="button" class="btn btn-secondary me-1" (click)="activeModal.close()">
        <fa-icon [icon]="['fas', 'ban']"></fa-icon>&nbsp;
        {{ 'cancel.modal.label' | translate | titlecase }}
    </button>
</div>